<template>
  <l-cache :get-data="getUser" :id="this.$route.query.id" ref="cache">
    <template slot-scope="{data}">
      <user-details-edit :data="data" @refresh="refresh()" status="edit"></user-details-edit>
    </template>
  </l-cache>
</template>

<script>
import UserDetailsEdit from './userDetailsEdit'

export default {
  name: 'EditUser',
  components: {UserDetailsEdit},
  data: () => ({}),
  methods: {
    async getUser (key) {
      let {items} = await this.$store.dispatch('userAdmin/getUsers', {
        pagination: {page: 1},
        filter: {id: key}
      })
      return items[0]
    },
    refresh () {
      if (this.$refs.cache) {
        this.$refs.cache.retry(true)
      }
    }
  },
  created () {
    console.log('new user create')
  },
}
</script>

<style scoped>

</style>
